import $ from "jquery";

const Paintings = {
  elms: {
    screen: ".frame-0",
    screenImg: ".item-0",
    screen2: ".frame-1",
    screenImg2: ".item-1",
    screen3: ".frame-2",
    screenImg3: ".item-2",
    screen4: ".frame-3",
    screenImg4: ".item-3",
    screen5: ".frame-4",
    screenImg5: ".item-4",
  },

  resetCalculation: function () {
    [this.elms.screenImg, this.elms.screenImg2, this.elms.screenImg3, this.elms.screenImg4, this.elms.screenImg5].forEach((selector) => {
      $(selector).removeAttr("style");
    });
    $("body")[0].offsetWidth;
  },

  getBoundingBox: function (selector) {
    const elements = document.querySelectorAll(`svg path${selector}`);
    if (!elements.length) return null;

    return Array.from(elements).reduce(
      (acc, el) => {
        const bbox = el.getBoundingClientRect();
        return {
          maxWidth: Math.max(acc.maxWidth, bbox.width),
          maxHeight: Math.max(acc.maxHeight, bbox.height),
          minX: Math.min(acc.minX, bbox.left),
          minY: Math.min(acc.minY, bbox.top),
        };
      },
      { maxWidth: 0, maxHeight: 0, minX: Infinity, minY: Infinity }
    );
  },

  calculateCoverSize: function () {
    this.resetCalculation();

 

    const screenBBox = this.getBoundingBox(this.elms.screen);
    const screen2BBox = this.getBoundingBox(this.elms.screen2);
    const screen3BBox = this.getBoundingBox(this.elms.screen3);
    const screen4BBox = this.getBoundingBox(this.elms.screen4);
    const screen5BBox = this.getBoundingBox(this.elms.screen5);

    if (screenBBox) {
      $(this.elms.screenImg).css({
        width: screenBBox.maxWidth,
        height: screenBBox.maxHeight,
        left: screenBBox.minX,
        top: screenBBox.minY,
      });
    }

    if (screen2BBox) {
      $(this.elms.screenImg2).css({
        width: screen2BBox.maxWidth,
        height: screen2BBox.maxHeight,
        left: screen2BBox.minX,
        top: screen2BBox.minY,
      });
    }

    if (screen3BBox) {
      $(this.elms.screenImg3).css({
        width: screen3BBox.maxWidth,
        height: screen3BBox.maxHeight,
        left: screen3BBox.minX,
        top: screen3BBox.minY,
      });
    }

    if (screen4BBox) {
      $(this.elms.screenImg4).css({
        width: screen4BBox.maxWidth,
        height: screen4BBox.maxHeight,
        left: screen4BBox.minX,
        top: screen4BBox.minY,
      });
    }

    if (screen5BBox) {
      
      $(this.elms.screenImg5).css({
        width: screen5BBox.maxWidth,
        height: screen5BBox.maxHeight,
        left: screen5BBox.minX,
        top: screen5BBox.minY,
      });
    }

    return true;
  },
};

export default Paintings;
